import React, { useEffect } from 'react'

import * as S from './styles'
import { Image } from '@/components'
import { useIsVisibleElement } from '@/hooks/useIsVisibleElement'

export type BlogPostHeaderProps = {
  /**
   * Image url of the header article
   *
   * @example
   * ```tsx
   * <BlogPostHeader imageSrc="https://picsum.photos/200/300" />
   * ```
   *
   */
  imageSrc: string

  /**
   * Image alt of the header article
   *
   * @example
   * ```tsx
   * <BlogPostHeader imageAlt="Alt da imagem" />
   * ```
   *
   * @default ""
   */
  imageAlt?: string
}

export const BlogPostHeader: React.FC<BlogPostHeaderProps> = ({
  imageSrc,
  imageAlt = '',
}) => {
  const { element, scrollbar } = useIsVisibleElement()

  useEffect(() => {
    const handleScroll = () => {
      const scroll = scrollbar.current?.scrollTop || 0 - window.innerHeight
      if (element.current) {
        const image = element.current.firstChild as HTMLImageElement
        image.style.transform = `translate3d(0, -${scroll / 100}%, 0) scale(${
          (100 + scroll / 5) / 100
        })`
      }
    }
    const newScrollbar = scrollbar.current
    newScrollbar?.addListener(handleScroll)

    return () => newScrollbar?.removeListener(handleScroll)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <S.HeaderContainer>
      <div className="container-img" ref={element}>
        <Image
          src={imageSrc}
          alt={imageAlt}
          fill
          style={{ objectFit: 'cover' }}
          priority
        />
      </div>
    </S.HeaderContainer>
  )
}
